import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

const LogoIcon = () => {
  const theme = useTheme();

  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      <svg width="40" height="40" viewBox="0 0 24 24" fill={theme.palette.primary.main} xmlns="http://www.w3.org/2000/svg">
        <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
      </svg>
    </Box>
  );
};

export default LogoIcon;
